var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.66675H2.66659C1.93021 2.66675 1.33325 3.2637 1.33325 4.00008V12.0001C1.33325 12.7365 1.93021 13.3334 2.66659 13.3334H13.3333C14.0696 13.3334 14.6666 12.7365 14.6666 12.0001V4.00008C14.6666 3.2637 14.0696 2.66675 13.3333 2.66675Z",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 4.66675L8.68658 8.46675C8.48077 8.5957 8.2428 8.66409 7.99992 8.66409C7.75704 8.66409 7.51907 8.5957 7.31325 8.46675L1.33325 4.66675",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7709288402eec11de6b0a88b3fb6a239.svg";
export { ForwardRef as ReactComponent };